import React, { useState, useEffect } from 'react';
import './AnnouncementBar.css';
import { Leaf, Truck, Tag, Gift, Sparkles, Star, Percent, Heart, Phone } from 'lucide-react';
import { useSiteLayout } from '../../context/SiteLayoutContext';
import SmartLink from '../SmartLink/SmartLink';

const ICONS = { truck: Truck, tag: Tag, leaf: Leaf, gift: Gift, sparkles: Sparkles, star: Star, percent: Percent, heart: Heart, phone: Phone };

// Rotating messages — Admin → Customize → Announcement Bar
const AnnouncementBar = () => {
  const { layout, loaded } = useSiteLayout();
  const content = layout?.announcement;
  const items = content?.items || [];
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (index >= items.length) setIndex(0);
  }, [items.length, index]);

  useEffect(() => {
    if (items.length < 2) return undefined;
    const ms = Math.max(2, content?.rotateSeconds || 4.5) * 1000;
    const timer = setInterval(() => setIndex(prev => (prev + 1) % items.length), ms);
    return () => clearInterval(timer);
  }, [items.length, content?.rotateSeconds]);

  // Turned off in admin
  if (loaded && !content) return null;
  // First visit, still loading: keep the bar's space so the page doesn't jump
  if (!content) return <div className="announcement-bar" aria-hidden="true" />;

  const current = items[index] || items[0];
  if (!current) return null;
  const IconComponent = ICONS[current.icon];

  return (
    <div
      className="announcement-bar"
      role="region"
      aria-label="Store Announcement"
      style={{ backgroundColor: content.bgColor, color: content.textColor }}
    >
      <SmartLink key={current.id} to={current.link} className="announcement-content" fallbackTag="div">
        {IconComponent && <IconComponent size={13} className="announcement-icon" />}
        <span className="announcement-text">{current.text}</span>
      </SmartLink>
    </div>
  );
};

export default AnnouncementBar;
